import React, { useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import styled from 'styled-components';
import moment from 'moment';
import FA from 'admin/components/atoms/FontAwesome';
import { getMaintenanceSchedule } from 'admin/actions/maintenance';

const Wrapper = styled.div`
  display: ${(props) => (props.hide ? 'none' : 'block')};
  position: fixed;
  right: 30px;
  bottom: 30px;
  width: 400px;
  height: 110px;
  background-color: white;
  border-radius: 5px;
  box-shadow: 2px 2px 10px gray;
  padding: 20px 30px 20px 20px;
`;

const CloseButton = styled.a`
  position: absolute;
  top: 5px;
  right: 10px;
  color: gray;
  &:hover {
    color: black;
  }
`;

const maintenanceBaseURLs = {
  'admin.pokepay.jp': 'https://maintenance.pokepay.jp',
  'admin-sandbox.pokepay.jp': 'https://maintenance-sandbox.pokepay.jp',
  'admin-qa.pokepay.jp': 'https://maintenance-qa.pokepay.jp',
  'admin-load-test.pokepay.jp': 'https://maintenance-qa.pokepay.jp',
  'admin-dev.pokepay.jp': 'https://maintenance-dev.pokepay.jp',
};

const SystemNotification = ({ notification, getMaintenanceSchedule }) => {
  const [message, setMessage] = useState();

  useEffect(() => {
    const baseURL =
      maintenanceBaseURLs[window.location.hostname] || 'https://maintenance-dev.pokepay.jp';
    getMaintenanceSchedule(baseURL).catch(async (err) => {
      const res = await err;
      console.error(res);
    });
  }, []);

  useEffect(() => {
    const { current_timestamp, maintenance_schedule } = notification.maintenance;
    const { start_at, end_at, _ } = maintenance_schedule;
    const current_datetime = moment(current_timestamp);
    const start_datetime = moment(start_at);
    const end_datetime = moment(end_at);
    if (current_datetime <= end_datetime) {
      const formated_start = start_datetime.format('YYYY/MM/DD HH:mm:ss');
      const formated_end = end_datetime.format('YYYY/MM/DD HH:mm:ss');
      setMessage(
        `計画メンテナンスのお知らせ<br>開始予定: ${formated_start}<br>終了予定: ${formated_end}`
      );
    }
  }, [notification]);

  const onClose = (e) => {
    e.preventDefault();
    setMessage(null);
  };

  const existMessage = () => typeof message === 'string';

  return (
    <Wrapper hide={!existMessage()}>
      <CloseButton href="#" onClick={onClose}>
        <FA icon="times-circle" />
      </CloseButton>
      <div dangerouslySetInnerHTML={{ __html: message }}></div>
    </Wrapper>
  );
};

const mapStateToProps = (state) => {
  return {
    notification: state.systemNotification,
  };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({ getMaintenanceSchedule }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SystemNotification);
